export default __webpack_public_path__ + "static/media/ISTANBUL.82ace9d0.jpg";